import React, { FC, ReactElement, useContext } from 'react'
import { Location, NavigateFunction, useLocation, useNavigate } from 'react-router'
import { useFormContext, UseFormMethods } from '../../../../../Vendor/react-hook-form/dist/index.ie11'
import { ForgotPasswordLanguage } from '../../../../../../i18n'
import { RoundedButton } from '../../../Atoms/RoundedButton/RoundedButton'
import CLanguageHandler from '../../../../../NonReact/Languages/LanguageHandler'
import { LanguageContext } from '../../../../../React/Common/Contexts'
import { AUTH_ROUTE_PATH } from '../../../../Constants/Constants'

type Props = {
    submitHandler: () => void
    isReCaptchaInvisible: boolean
    isReCaptchaEnabled: boolean
}

export const FooterActions: FC<Props> = ({
    submitHandler,
    isReCaptchaInvisible,
    isReCaptchaEnabled
}: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler

    const location: Location = useLocation()
    const navigate: NavigateFunction = useNavigate()

    const {
        formState: { isValid }
    }: UseFormMethods = useFormContext()

    return (
        <div className='fp-footer'>
            <RoundedButton
                type='button'
                className='lf-login-button'
                onClick={(): void => navigate(AUTH_ROUTE_PATH, { state: { from: location } })}
            >
                {language.get(ForgotPasswordLanguage.ForgotPassword_Actions_Cancel)}
            </RoundedButton>
            <RoundedButton
                className='lf-login-button'
                disabled={!isValid && !isReCaptchaInvisible && isReCaptchaEnabled}
                type='button'
                onClick={submitHandler}
            >
                {language.get(ForgotPasswordLanguage.ForgotPassword_Actions_Continue)}
            </RoundedButton>
        </div>
    )
}
